var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSmile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 108.46 93.55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f7f7f7;}.cls-2{fill:#fff;}.cls-3{fill:#707071;}.cls-4{fill:#d8d8d8;opacity:0.7;}.cls-5{fill:#c3c4c4;}.cls-6{fill:#999;}.cls-7{fill:#636666;}.cls-8{fill:#e6e9e9;}.cls-9{fill:#919190;}.cls-10{fill:#676868;}.cls-11{fill:#606161;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\uC790\uC0B0 6@1x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uB808\\uC774\\uC5B4_2",
    "data-name": "\\uB808\\uC774\\uC5B4 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uB808\\uC774\\uC5B4_1-2",
    "data-name": "\\uB808\\uC774\\uC5B4 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M107.6,93.55C104.13,65,95,45.16,95,45.16l.53-.27a5.11,5.11,0,0,0,3.21-3.29,7.32,7.32,0,0,0,.3-2.05,5.09,5.09,0,0,0,5.37-7.37c3-.72,4.44-4.53,3-7.2a6,6,0,0,0-1.34-1.61c3.22-1.55,2.91-6.66.61-8.8a5.42,5.42,0,0,0-2.24-1.26c2.45-3.68-.73-9.55-5.13-9.28-3.28.2-4.12,3-5,5.69C88.37,27.56,68.08,20.09,68.08,20.09c-8.52-3-19.24-3.23-27.7,0l-.64.21S20.09,27.56,14.14,9.72c-.88-2.65-1.72-5.49-5-5.69C4.74,3.76,1.56,9.63,4,13.31a5.57,5.57,0,0,0-2.25,1.26c-2.3,2.14-2.6,7.25.62,8.8A6,6,0,0,0,1,25c-1.4,2.67,0,6.48,3,7.2a5.29,5.29,0,0,0,.51,5.49,5.3,5.3,0,0,0,4.86,1.88,7.32,7.32,0,0,0,.3,2.05A5.11,5.11,0,0,0,13,44.89l.53.27S4.33,65,.86,93.55"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M12.68,45.27A5.06,5.06,0,0,0,16.81,45a6.24,6.24,0,0,0,4.91,2.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M21.26,47.66a6.68,6.68,0,0,1-4.56-2,5.59,5.59,0,0,1-4.21.11.5.5,0,1,1,.39-.92,4.64,4.64,0,0,0,3.68-.24.5.5,0,0,1,.63.11,5.74,5.74,0,0,0,4.49,2,.5.5,0,0,1,.09,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M95.9,45.27A5.06,5.06,0,0,1,91.77,45a6.24,6.24,0,0,1-4.91,2.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M87.32,47.66l-.51,0a.51.51,0,0,1-.45-.55.52.52,0,0,1,.54-.45,5.76,5.76,0,0,0,4.49-2,.5.5,0,0,1,.63-.11,4.58,4.58,0,0,0,3.68.24.5.5,0,0,1,.4.92,5.57,5.57,0,0,1-4.22-.11A6.68,6.68,0,0,1,87.32,47.66Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 28.42,
    cy: 57.56,
    rx: 6.26,
    ry: 3.75
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 80.04,
    cy: 57.56,
    rx: 6.26,
    ry: 3.75
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M41,19.44s-.82-.08-.82,1.5v3.72s.63,3.1,13.88,3.1c0,0,12.06.69,13.87-3.1V20.23s.07-1.1-.79-1.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M56.31,28.06c-1.25,0-2.11,0-2.24,0h0C40.79,28,40,24.84,40,24.71V20.94a2,2,0,0,1,.48-1.51.86.86,0,0,1,.62-.24l-.05.5,0-.25,0,.25a.39.39,0,0,0-.25.12,1.53,1.53,0,0,0-.3,1.13v3.72h0s1,2.85,13.63,2.85c.13,0,11.82.63,13.62-2.91V20.23a1,1,0,0,0-.2-.72.42.42,0,0,0-.34-.13v-.5a.94.94,0,0,1,.71.29,1.53,1.53,0,0,1,.33,1.07l0,4.53C66.8,27.67,59.94,28.06,56.31,28.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M66.49,15.9c.82,0,.75,1,.75,1v4.2c-13.15,5.55-26.31,0-26.31,0V17.62c0-1.5.78-1.42.78-1.42"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M54.61,23.84a39.41,39.41,0,0,1-13.78-2.47l-.15-.06V17.62a1.9,1.9,0,0,1,.46-1.45.8.8,0,0,1,.59-.22l0,.5a.33.33,0,0,0-.22.1,1.48,1.48,0,0,0-.28,1.07V21c1.5.59,13.72,5,25.81,0v-4a1,1,0,0,0-.18-.67.42.42,0,0,0-.32-.12v-.5a.9.9,0,0,1,.68.28,1.46,1.46,0,0,1,.32,1v4.35l-.15.06A32.68,32.68,0,0,1,54.61,23.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M41.29,15.77A5.33,5.33,0,0,0,39,16.93s11.81,2.81,15.11,4.39c0,0,13.54-4.52,15.27-4.39a3.63,3.63,0,0,0-2.12-1.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M54.07,21.58l-.09,0C50.75,20,39,17.2,38.92,17.18l-.45-.11.34-.32a5.54,5.54,0,0,1,2.43-1.23l.1.49a5.44,5.44,0,0,0-1.81.8c2.27.55,11.54,2.83,14.57,4.24,1.21-.4,11.69-3.88,14.68-4.32A3.33,3.33,0,0,0,67.21,16l.07-.49a4,4,0,0,1,2.28,1.25l.36.46-.58-.05h-.07c-1.64,0-11.41,3.14-15.11,4.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M41.29,13.84v1.87s10.05,3.89,25.95,0V12.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M53.5,17.68a37.48,37.48,0,0,1-12.3-1.74L41,15.88v-2h.5v1.69c1.34.47,11,3.47,25.45,0V12.08h.5v3.83l-.19,0A57.71,57.71,0,0,1,53.5,17.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M66.39,9.18c4.84.12,3.94,2.87,3.94,2.87-.41,1.81-2.52,1.46-2.52,1.46-1.78-1.08-4.35-.35-4.35-.35-1.43.32-2.38,1.89-3.75,2.33a1.22,1.22,0,0,1-.42.06c-1.77,0-3.48-1.24-5.28-.92s-3.28,1.55-5.06,1c-1.5-.46-2.85-1.9-4.42-1.9h-.24c-1.52.09-3.15.57-4.63-.28l0,0s-2.08-1.26-1.46-2.94c0,0,.68-1.64,3.34-1.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M66.39,9.43c1.39.08,4.14.46,3.71,2.48s-2.28,1.15-3.49.88a6.66,6.66,0,0,0-3.17.11c-2.25.66-2.76,2.68-5.59,2.16-1.7-.31-2.88-1-4.64-.49s-3,1.23-4.79.54c-.88-.34-1.61-1-2.49-1.31-2-.77-4.14.41-6.15-.57-.73-.35-.87-.9-1.1-1.66-.53-1.82.83-2.2,2.74-1.91.32.05.45-.43.14-.48-3.12-.47-5.43,2.35-2.14,4.41a4.68,4.68,0,0,0,2.54.6c.86,0,1.71-.26,2.57-.21,1.49.1,2.39,1.08,3.66,1.61a4.32,4.32,0,0,0,3,.21c.74-.17,1.41-.56,2.14-.75,1.64-.42,2.82.13,4.37.49,2.89.68,3.49-1.56,6.15-2.22,1.54-.39,2.66.35,4.11.46a2.64,2.64,0,0,0,2-.6A2.3,2.3,0,0,0,70.56,11c-.5-1.73-2.68-1.94-4.17-2-.32,0-.32.48,0,.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M68.05,10.21s-.31-10-12.8-10h-2c-12.5,0-12.81,10-12.81,10S51.66,14.91,68.05,10.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M53.67,12.53a38,38,0,0,1-13.29-2.09l-.16-.06V10.2c0-.1.46-10.2,13.06-10.2h2c12.59,0,13,10.1,13,10.2v.2l-.19,0A52.43,52.43,0,0,1,53.67,12.53ZM40.74,10c1.44.55,12.11,4.21,27.05,0C67.68,8.62,66.54.5,55.25.5h-2C42.08.5,40.86,8.74,40.74,10Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 54.18,
    cy: 2.02,
    rx: 0.35,
    ry: 0.26
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 52.31,
    cy: 3.66,
    rx: 0.35,
    ry: 0.26
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 55.86,
    cy: 3.66,
    rx: 0.35,
    ry: 0.26
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 57.78,
    cy: 2.41,
    rx: 0.35,
    ry: 0.26
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 50.54,
    cy: 2.41,
    rx: 0.35,
    ry: 0.26
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M54.23,55.22a4.49,4.49,0,1,0-4.49-4.49A4.5,4.5,0,0,0,54.23,55.22Zm0-6.36a1.87,1.87,0,1,1-1.87,1.87A1.87,1.87,0,0,1,54.23,48.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M63.33,61.75a14.41,14.41,0,0,1-7.79,3.14V58.28a1.31,1.31,0,0,0-2.62,0v6.61a14.48,14.48,0,0,1-7.8-3.14,1.31,1.31,0,0,0-1.63,2,17.18,17.18,0,0,0,21.48,0,1.31,1.31,0,0,0-1.64-2Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-11",
    cx: 45.26,
    cy: 42.31,
    r: 2.26
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-11",
    cx: 63.19,
    cy: 42.31,
    r: 2.26
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmile);
export default __webpack_public_path__ + "static/media/Smile.1e2e048535c61aee8868e22d180192c7.svg";
export { ForwardRef as ReactComponent };